import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      alias: ['', '/', '#'],
      component: () => import('./views/Home.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/serve',
      component: () => import('./views/Serve.vue'),
      children: [{
        path: '',
        name: 'serve',
        component: () => import('./views/Server.vue')
      }, {
        path: '/server_collect',
        name: 'server_collect',
        component: () => import('./views/ServerCollect.vue')
      }, {
        path: '/server_info',
        name: 'server_info',
        component: () => import('./views/ServerInfo.vue')
      }, {
        path: '/collect/:id/:title',
        name: 'collect',
        component: () => import('./views/CollectView/CollectView.vue')
      }, {
        path: '/consult/:id/:title',
        name: 'consult',
        component: () => import('./views/Consult/Consult.vue')
      }, {
        path: '/feedback/:id/:title',
        name: 'feedback',
        component: () => import('./views/Feedback/Feedback.vue')
      }, {
        path: '/server_search',
        name: 'server_search',
        component: () => import('./views/SearchInfo.vue')
      }, {
        path: '/server_my_office',
        name: 'server_my_office',
        component: () => import('./views/ServerMyOffice.vue')
      }]
    }
    // {
    //   path: '/office',
    //   redirect: '/office/officeSign',
    //   component: () => import('./views/OfficeNew/OfficeNew.vue'),
    //   children: [
    //     // 个人中心
    //     {
    //       path: '/office/officeSign',
    //       name: 'officeSign',
    //       component: () => import('./views/OfficeNew/OfficeSign/OfficeSign.vue')
    //     },
    //     {
    //       path: '/office/officeSeal',
    //       name: 'officeSeal',
    //       component: () => import('./views/OfficeNew/OfficeSeal/OfficeSeal.vue')
    //     },
    //     // 办事大厅
    //     {
    //       path: '/office/officeSubject',
    //       name: 'officeSubject',
    //       component: () => import('./views/OfficeNew/OfficeSubject/OfficeSubject.vue')
    //     },
    //     {
    //       path: '/office/OfficeBiz',
    //       name: 'OfficeBiz',
    //       component: () => import('./views/OfficeNew/OfficeBiz/OfficeBiz.vue')
    //     },
    //     {
    //       path: '/office/officeRoleForDepartment',
    //       name: 'officeRoleForDepartment',
    //       component: () => import('./views/OfficeNew/OfficeRoleForDepartment/OfficeRoleForDepartment.vue')
    //     },
    //     {
    //       path: '/office/officeRoleDepartment',
    //       name: 'officeRoleDepartment',
    //       component: () => import('./views/OfficeNew/OfficeRoleDepartment/OfficeRoleDepartment.vue')
    //     },
    //     {
    //       path: '/office/officeRoleCollege',
    //       name: 'officeRoleCollege',
    //       component: () => import('./views/OfficeNew/OfficeRoleCollege/OfficeRoleCollege.vue')
    //     },
    //     // 办公区
    //     {
    //       path: '/office/officeServeGroup',
    //       name: 'officeServeGroup',
    //       component: () => import('./views/OfficeNew/OfficeServeGroup/OfficeServeGroup.vue')
    //     },
    //     {
    //       path: '/office/officeRoleForHref',
    //       name: 'officeRoleForHref',
    //       component: () => import('./views/OfficeNew/OfficeRoleForHref/OfficeRoleForHref.vue')
    //     },
    //     // 车辆
    //     {
    //       path: '/office/officeCar',
    //       name: 'officeCar',
    //       component: () => import('./views/OfficeNew/OfficeCar/OfficeCar.vue')
    //     }, {
    //       path: '/office/officeCarHistory',
    //       name: 'officeCarHistory',
    //       component: () => import('./views/OfficeNew/OfficeCarHistory/OfficeCarHistory.vue')
    //     }
    //   ]
    // }
    // {
    //   path: '/serveCount',
    //   redirect: '/serveCount/ByPersonal',
    //   component: () => import('./views/ServeCount/ServeCount.vue'),
    //   children: [{
    //     path: '/serveCount/byHall',
    //     name: 'byHall',
    //     component: () => import('./views/ServeCount/ByHall/ByHall.vue')
    //   }, {
    //     path: '/serveCount/byDept',
    //     name: 'byDept',
    //     component: () => import('./views/ServeCount/ByDept/ByDept.vue')
    //   }, {
    //     path: '/serveCount/byCollege',
    //     name: 'byCollege',
    //     component: () => import('./views/ServeCount/ByCollege/ByCollege.vue')
    //   }, {
    //     path: '/serveCount/byPersonal',
    //     name: 'byPersonal',
    //     component: () => import('./views/ServeCount/ByPersonal/ByPersonal.vue')
    //   }]
    // }
  ]
})
